import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '~/api/utils/api-base';
import { reactQueryClient } from '~/shared/contexts/CommonAppContext';
import { Chart, ChordSection, CreateableChart, LyricSection, UpdatableChart } from '~/shared/types/chart';

export const useFetchCharts = () => {
  return useQuery({
    queryKey: ['charts'],
    queryFn: async () => {
      const response = await api.get<Chart[]>('/charts');
      return response.data;
    },
    staleTime: 1000 * 60 * 60 * 24,
  });
};

export const useFetchNewChart = () => {
  return useQuery(
    {
      queryKey: ['charts', 'new'],
      queryFn: async () => {
        const response = await api.get<Chart>('/charts/new');
        return response.data;
      },
    });
};

export const useFetchChart = (id: number) => {
  return useQuery(
    {
      queryKey: ['charts', id],
      queryFn: async () => {
        const response = await api.get<Chart>(`/charts/${id}`);
        return response.data;
      },
    });
};

// mutation for updating chart
export const useUpdateChart = () => {
  return useMutation({
    mutationFn: async ({ id, updatableChart }: { id: number, updatableChart: UpdatableChart }) => {
      const response = await api.put<Chart>(`/charts/${id}`, updatableChart);
      return response.data;
    },
  })
};

export const useCreateChart = () => {
  return useMutation({
    mutationFn: async ({ chartNew }: { chartNew: CreateableChart }) => {
      const response = await api.post<Chart>(`/charts`, chartNew);
      return response.data;
    },
  })
}

export const useDestroyChart = () => {
  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const response = await api.delete<Chart>(`/charts/${id}`);
      return response.data;
    },
  })
}